<template>
    <div class="list">
        <NavBar></NavBar>
        <div v-if="isShow" style="margin-top:60px">
            <van-empty image="error" description="查询失败或房屋已交存" />
        </div>
        <div v-if="!isShow" class="contentInclude">
            <van-col span="24" style="font-size:14px;font-weight:bold">{{houseObj.houseSite}}</van-col>
            <van-col span='24' style="font-size:12px;color:gray;margin:10px 0 20px 0">房屋交易业务编号:{{contractNo}}</van-col>
            <van-row type="flex"  justify="space-between">
                <van-col span="6" style="text-align:center">
                    <div style="font-weight:bold;margin-bottom:7px">{{houseObj.struArea}}</div>
                    <div style="font-size:12px;color:gray">建筑面积(㎡)</div>
                </van-col>
                <van-col span="7" style="text-align:center">
                    <div style="font-weight:bold;margin-bottom:7px">{{houseObj.ratio}}</div>
                    <div style="font-size:12px;color:gray">交存标准(元/㎡)</div>
                </van-col>
                <van-col span="6" style="text-align:center">
                    <div style="font-weight:bold;margin-bottom:7px;color: rgb(89, 195, 236);">{{houseObj.amountDue}}</div>
                    <div style="font-size:12px;color:gray">应交金额(元)</div>
                </van-col>
            </van-row>
        </div>
        <div class="flex">
            <van-col :span="24" class="house_button">
                <van-button type="danger" size="normal" :disabled='isShow'  @click="openImad">立即交存</van-button>
            </van-col>
        </div>
        <!-- 弹出框 -->
        <!-- <van-action-sheet v-model:show="Popup" title="支付" :style="{ height: '60%' }">
            <div class="content">
                <van-col span='24' style="text-align:center;font-size:26px;font-weight:bold;color:skyblue">20000.00</van-col>
                <van-col span='24' style="text-align:center;font-size:12px;color:gray;margin-top:10px">交易金额(元)</van-col>
                <van-col span='24' style="margin-top:35px">
                    <van-cell :value="payText" is-link @click="openShow">
                        <template #title>
                            <span class="custom-title">请选择支付方式</span>
                        </template>
                    </van-cell>
                    <van-popup v-model:show="showPicker" position="bottom">
                        <van-picker :columns="columns"  @confirm="onConfirm"  :default-index="seachss"  @cancel="showPicker = false"/>
                    </van-popup>
                </van-col>
                <div class="flexSon">
                    <van-col :span="24" class="house_button">
                        <van-button type="danger" size="normal"   @click="openPay">立即支付</van-button>
                    </van-col>
                </div>
            </div>
        </van-action-sheet> -->
        <!--  -->
    </div>
</template>

<script>
    import VueCookie from 'vue-cookie'
    // import wx from 'weixin-js-sdk'  
    export default {
        data(){
            return{
                houseObj:{},
                obj:{},
                contractNo:'',
                depositType:'',
                ownerName:'',
                ownerNo:'',
                isShow:false,
                seachss:0,
                Popup:false,
                payValue:'1',
                payText:'微信零钱',
                columns: [{ text: '微信零钱', id:"1"},{text:'建设银行卡支付',id:'2'}],
                showPicker: false,
            }
        },
        methods:{
            imatePay(){
                var _this=this;
                let data={
                    openId:VueCookie.get('openid'),
                    roomNo:this.houseObj.houseId,
                    contractNo:this.contractNo,
                    totalFee:parseFloat(this.houseObj.amountDue)*100,
                }
                this.$postQuery('/WeChatPay/createOrder', data).then((response) => {
                    WeixinJSBridge.invoke('getBrandWCPayRequest', {
                        appId:response.obj.appId ,     //公众号ID，由商户传入     
                        timeStamp: response.obj.timeStamp,     //时间戳，自1970年以来的秒数     
                        nonceStr: response.obj.nonceStr,      //随机串     
                        package: response.obj.package,
                        signType: response.obj.signType,     //微信签名方式：
                        paySign: response.obj.paySign, //微信签名 
                    },
                    function(res) {
                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                            _this.$router.replace({
                                path:'/DepositDetails'
                            })
                        }
                    })
                })
            },
            openImad(){
                var _this = this;
                if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', _this.imatePay(), false);
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', _this.imatePay());
                        document.attachEvent('onWeixinJSBridgeReady', _this.imatePay());
                    }
                } else {
                    _this.imatePay()
                }
                // let data = {
                //     openId:VueCookie.get('openid'),
                //     roomNo:this.houseObj.houseId,
                //     contractNo:this.contractNo,
                //     totalFee:parseFloat(this.houseObj.amountDue)*100,
                // }
                // this.$postQuery('/WeChatPay/createOrder', data).then((response) => {
                //     wx.chooseWXPay({
                //         timestamp: response.obj.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                //         nonceStr: response.obj.nonceStr, // 支付签名随机串，不长于 32 位
                //         package: response.obj.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                //         signType:response.obj.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                //         paySign: response.obj.paySign, // 支付签名
                //         success: function (res) {
                //             _this.$router.replace({
                //                 path:'/DepositDetails'
                //             })
                //             console.log(res);
                //         }
                //     });
                // })
            },
            openShow(){
                this.showPicker = true;
               
            },
            onConfirm(value) {
                console.log(value)
                this.payValue = value.id;
                this.payText = value.text;
                this.showPicker = false;
            },
            openPay(){
                console.log(this.payText)
                console.log(this.payValue)
            },
            // ShowList(){
            //     let data={
            //         contractNo:this.contractNo,
            //         depositType:this.depositType,
            //         ownerName:this.ownerName,
            //         ownerNo:this.ownerNo
            //     }
            //     this.$postQuery('/WeChat/getDepositInfoByContractNo', data)
            //     .then((response)=>{
            //         console.log(response)
            //         if(response.code==200){
            //             if(!response.data.obj){
            //                 this.isShow = true
            //             }else{
            //                 this.obj = response.data.obj
            //             }
            //         }
            //     })
            // }
        },
        created(){
            this.houseObj = JSON.parse(this.$route.query.houseObj)
            this.contractNo=this.$route.query.contractNo
            console.log(this.houseObj)
            // this.contractNo = this.$route.query.scanQRCodeValue
            // this.depositType = this.$route.query.depositType
            // this.ownerName = this.$route.query.ownerName
            // this.ownerNo = this.$route.query.ownerNo
            // this.ShowList()
        }
    }
</script>

<style scoped>
    .list {
        margin-top: 46px;
        
    }

    .contentInclude {
        border: 1px solid rgb(238, 236, 236);
        padding: 14px 10px;
        margin: 20px 6px;
        border-radius: 5px;
        box-shadow: 2px 3px 12px #ebedf0;
    }
    .flex {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .content {
        padding: 40px 16px 160px 16px;
    }
    .flexSon{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    /* .flexSon .van-button{
        width: 100%;
    } */
    .flexSon .house_button{
        margin: 10px;
    }
    .flexSon .house_button .van-button,.content_button .van-button{
        padding: 3px 15px;
        width: 100%;
    }
    .flex .house_button{
        margin: 10px;
    }
    .flex .house_button .van-button,.content_button .van-button{
        padding: 3px 15px;
        width: 100%;
    }
    /* box-shadow: 2px 3px 12px #ebedf0; */
</style>